var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { memo, useCallback, useRef, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import LazyLoad from 'react-lazyload';
import urlApi from '../../../../../actions/urlApi';
import { DragDropContext } from 'react-beautiful-dnd';
import { LayoutConst, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE } from '../../../../../constants/media';
import useResizedPostImage from '../../../../../hooks/useResizedPostImage';
import AspectRatio from '../../../../AspectRatio';
import { FontSizes, MAC13_COLORED_FONT_SIZE, POST_SHADOW } from '../../../../../constants/theme';
import { FlexBox, useBreakpoint, useResizedImage, useToasts } from '@brg/ui';
import { VoteRadioBlock } from '../components/voteradioblock';
import { VoteAdminBlock } from '../components/voteadminblock';
import { updateLongReadPost } from '../../../../../actions/updateLongReadPost';
import { getLongReadPosts } from '../../../../../actions/getLongReadPosts';
import VoteDragColumn from '../components/votedragcolumn';
import { API, Endpoints, LikeAPI } from '@brg/api';
import { useAuth, useFingerprintId, useProfile } from '@brg/auth';
import useLocalization from '../../../../../hooks/useLocalization';
import { VoteResultBlock } from '../components/voteresultblock';
import useCommonProps from '../../../../../hooks/useCommonProps';
import EditorOverlayNew from '../../editor/EditorOverlayNew';
import { OverlayInnerNew } from '../../editor/EditorOverlayNew/styles';
import { CardOverlayInner } from '../../editor/CardOverlay/styles';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding-top: ", ";\n\n  &:hover {\n    .drag__hide {\n      display: flex;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n  }\n"], ["\n  position: relative;\n  padding-top: ", ";\n\n  &:hover {\n    .drag__hide {\n      display: flex;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n  }\n"])), function (_a) {
    var blockOffset = _a.blockOffset;
    return (blockOffset ? '30px' : 0);
}, OverlayInnerNew, CardOverlayInner);
var NEW_TEXT_FORMATTING_THRESHOLD = new Date(2022, 4, 5, 13).getTime();
var BigImageBlock = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  max-height: 200vw;\n  overflow: hidden;\n\n  transform: ", ";\n  transform-origin: ", ";\n  right: ", ";\n  top: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  opacity: ", ";\n  background-color: #000000;\n\n  a {\n    display: block;\n  }\n\n  .edit__toggle {\n    display: none;\n  }\n\n  .img-wrapper {\n    width: 564px !important;\n    max-height: 792px !important;\n\n    @media (max-width: 1440px), (max-height: 920px) {\n      width: 432px !important;\n      max-height: 594px !important;\n    }\n\n    @media (max-width: ", "px) {\n      width: 100% !important;\n      max-height: none !important;\n      height: auto !important;\n    }\n  }\n\n  img {\n    width: 564px !important;\n    height: 792px !important;\n    @media (max-width: 1440px), (max-height: 920px) {\n      width: 432px !important;\n      height: 594px !important;\n    }\n\n    @media (max-width: ", "px) {\n      width: 100% !important;\n      max-height: none !important;\n      height: auto !important;\n    }\n  }\n\n  &:hover {\n    .edit__toggle {\n      display: flex;\n      color: #151514;\n    }\n  }\n\n  @media (max-width: 940px) {\n    padding-left: ", ";\n    padding-right: ", ";\n\n    .lazy-img-container {\n      width: 100%;\n    }\n  }\n"], ["\n  position: relative;\n  max-height: 200vw;\n  overflow: hidden;\n\n  transform: ", ";\n  transform-origin: ", ";\n  right: ", ";\n  top: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  opacity: ", ";\n  background-color: #000000;\n\n  a {\n    display: block;\n  }\n\n  .edit__toggle {\n    display: none;\n  }\n\n  .img-wrapper {\n    width: 564px !important;\n    max-height: 792px !important;\n\n    @media (max-width: 1440px), (max-height: 920px) {\n      width: 432px !important;\n      max-height: 594px !important;\n    }\n\n    @media (max-width: ", "px) {\n      width: 100% !important;\n      max-height: none !important;\n      height: auto !important;\n    }\n  }\n\n  img {\n    width: 564px !important;\n    height: 792px !important;\n    @media (max-width: 1440px), (max-height: 920px) {\n      width: 432px !important;\n      height: 594px !important;\n    }\n\n    @media (max-width: ", "px) {\n      width: 100% !important;\n      max-height: none !important;\n      height: auto !important;\n    }\n  }\n\n  &:hover {\n    .edit__toggle {\n      display: flex;\n      color: #151514;\n    }\n  }\n\n  @media (max-width: 940px) {\n    padding-left: ", ";\n    padding-right: ", ";\n\n    .lazy-img-container {\n      width: 100%;\n    }\n  }\n"])), function (props) {
    return props.isDragging ? 'scale(0.4) rotate(10deg)' : 'scale(1)';
}, function (props) { return (props.isDragging ? 'left top' : 'center'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (_a) {
    var viewType = _a.viewType;
    return viewType === 'shadow' ? POST_SHADOW : 'none';
}, function (props) { return (props.isDragging ? '2' : '4'); }, function (props) { return (props.isLoadingPost ? '0.5' : '1'); }, MEDIA_QUERY_MOBILE, MEDIA_QUERY_MOBILE, function (props) { return (props.postType === 'normal' ? '15px' : '0'); }, function (props) { return (props.postType === 'normal' ? '15px' : '0'); });
var DragWrap = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: none;\n  align-items: center;\n  opacity: 0.3;\n  cursor: pointer;\n  margin-top: 10px;\n  position: absolute;\n  width: 100%;\n"], ["\n  display: none;\n  align-items: center;\n  opacity: 0.3;\n  cursor: pointer;\n  margin-top: 10px;\n  position: absolute;\n  width: 100%;\n"])));
var DragLine = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: 1px dashed #fefefe;\n  flex: 1;\n"], ["\n  border: 1px dashed #fefefe;\n  flex: 1;\n"])));
var DragText = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: #fefefe;\n  margin-left: 8px;\n"], ["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: #fefefe;\n  margin-left: 8px;\n"])));
var VoteAdminWrapper = styled(FlexBox)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  background-color: transparent;\n"], ["\n  width: 100%;\n  background-color: transparent;\n"])));
var progressAnim = keyframes(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n"], ["\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n"])));
var LoaderProgressBar = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  background: #f1db63;\n  top: 0;\n  left: 0;\n  height: 6px;\n  animation-name: ", ";\n  animation-fill-mode: forwards;\n  animation-direction: normal;\n  animation-duration: 1.5s;\n"], ["\n  position: absolute;\n  background: #f1db63;\n  top: 0;\n  left: 0;\n  height: 6px;\n  animation-name: ", ";\n  animation-fill-mode: forwards;\n  animation-direction: normal;\n  animation-duration: 1.5s;\n"])), progressAnim);
var OneImgBox = styled(FlexBox)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n\n  img {\n    width: 100% !important;\n    height: 100% !important;\n  }\n"], ["\n  width: 100%;\n\n  img {\n    width: 100% !important;\n    height: 100% !important;\n  }\n"])));
var getVotesImages = function (post) {
    var _a;
    return post &&
        ((_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a.reduce(function (res, item) {
            var _a = item.files, files = _a === void 0 ? [] : _a;
            return __spreadArray(__spreadArray([], res, true), [files], false);
        }, []));
};
var getLoadingVotesImages = function (post) {
    var _a;
    return post &&
        ((_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a.reduce(function (res, item) {
            var _a = item.file, file = _a === void 0 ? [] : _a;
            return __spreadArray(__spreadArray([], res, true), [file === null || file === void 0 ? void 0 : file.url], false);
        }, []));
};
var isUserVotedOrUndefined = function (votes, userId) {
    return votes === null || votes === void 0 ? void 0 : votes.some(function (i) { var _a; return (_a = i === null || i === void 0 ? void 0 : i.usersIdsLike) === null || _a === void 0 ? void 0 : _a.includes(userId); });
};
var getTotalCount = function (vote) {
    return vote.map(function (i) { return Number(i.count); }).reduce(function (sum, current) { return sum + current; }, 0);
};
var getTotalPercent = function (totalCount, count) {
    var total = (count * 100) / totalCount;
    if (total === 0 || isNaN(total))
        return 0;
    return total.toFixed();
};
export var ConditionalLazyLoad = function (_a) {
    var children = _a.children, className = _a.className, isLazy = _a.isLazy;
    if (isLazy)
        return (React.createElement(LazyLoad, { offset: 2000, once: true, className: className }, children));
    return React.createElement("div", { className: className }, children);
};
var VotePostBlock = function (props) {
    var _a, _b;
    var post = props.post, toggleLongReadPostUpdate = props.toggleLongReadPostUpdate, dragHandleProps = props.dragHandleProps, isDragging = props.isDragging, isDragContinue = props.isDragContinue, isEditable = props.isEditable, linkTo = props.linkTo, onOverlayedImageClick = props.onOverlayedImageClick, colorStyle = props.colorStyle, viewType = props.viewType, isAdmin = props.isAdmin, votesContent = props.votesContent, isUpdatePost = props.isUpdatePost, isSaveVoting = props.isSaveVoting;
    var dispatch = useDispatch();
    var auth = useAuth();
    var profile = useProfile();
    var toasts = useToasts();
    var t = useLocalization().t;
    var postType = useSelector(function (state) { return state.postType; });
    var container = useRef();
    var is375 = useBreakpoint(375);
    var isMac13 = useBreakpoint(MEDIA_QUERY);
    var smHeight = window.innerHeight < MEDIA_QUERY_HEIGHT;
    var _c = useCommonProps(), isPrint = _c.isPrint, disableVoting = _c.disableVoting, sign = _c.sign;
    var fingerprintId = useFingerprintId();
    var _d = useState([]), voteData = _d[0], setVoteData = _d[1];
    var _e = useState(''), currentVote = _e[0], setCurrentVote = _e[1];
    // добавлял ли админ результаты голосования из телеграмма
    var _f = useState(null), isAttachmentLiked = _f[0], setAttachmentLikes = _f[1];
    var _g = votesContent || {}, isSpVote = _g.isSpVote, isAuth = _g.isAuth, voteCollection = _g.voteCollection;
    var _h = getVotesImages(post), first = _h[0], second = _h[1];
    var _j = getLoadingVotesImages(post), firstLoading = _j[0], secondLoading = _j[1];
    var _k = useState(), vote1 = _k[0], setVote1 = _k[1];
    var _l = useState(), vote2 = _l[0], setVote2 = _l[1];
    var needLogin = useMemo(function () { return !profile; }, [profile]);
    var originalFirst = (first || [])[0];
    var secondFirst = (second || [])[0];
    var _m = useResizedImage(first !== null && first !== void 0 ? first : []), testFirst = _m[0], testFirstContainer = _m[1];
    var _o = useResizedImage(second !== null && second !== void 0 ? second : []), testSecond = _o[0], testSecondContainer = _o[1];
    var _p = originalFirst || {}, resizeFirstImage = _p.url, firstContainerId = _p.containerId;
    var _q = secondFirst || {}, resizeSecondImage = _q.url, secondContainerId = _q.containerId;
    var isUpdating = useMemo(function () { return post.postId === 'updating'; }, [post]);
    var smSize = useMemo(function () { return isMac13 || smHeight; }, [isMac13, smHeight]);
    // Для теста
    // const test = [
    //   {id: '123', count: 11120, percent: 72, },
    //   {id: '456', count: 0, percent: 28},
    // ]
    // const votes = test;
    var votes = useMemo(function () {
        var _a;
        if (voteData === null || voteData === void 0 ? void 0 : voteData.length) {
            return (_a = voteData === null || voteData === void 0 ? void 0 : voteData.map(function (v) {
                return __assign(__assign({}, v), { count: (v === null || v === void 0 ? void 0 : v.count) || 0 });
            })) === null || _a === void 0 ? void 0 : _a.map(function (i, idx, arr) {
                return __assign(__assign({}, i), { percent: getTotalPercent(getTotalCount(arr), i.count) });
            });
        }
        return [];
    }, [post, voteData]);
    var lastVote = useMemo(function () {
        var _a, _b;
        if (votes === null || votes === void 0 ? void 0 : votes.length) {
            return (_b = (_a = votes === null || votes === void 0 ? void 0 : votes.filter(function (v) {
                var _a;
                if ((_a = v === null || v === void 0 ? void 0 : v.usersIdsLike) === null || _a === void 0 ? void 0 : _a.includes(needLogin ? fingerprintId : profile === null || profile === void 0 ? void 0 : profile.accountId))
                    return v;
            })) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id;
        }
    }, [votes, profile, fingerprintId, needLogin]);
    var setCustomVote = function (id, postId, count) {
        API.request()
            .endpoint(Endpoints.qualities)
            .url('/Like/LikeOnCustomValue')
            .post()
            .body({
            entityId: id,
            entityType: 'superpuperimage',
            count: count
        })
            .send();
    };
    var fetchVotes = function (voteId, postId, callback, isUpdate) {
        LikeAPI.GetLike({
            entityId: voteId,
            entityType: 'superpuperimage'
        })
            .then(function (r) {
            if ((r === null || r === void 0 ? void 0 : r.status) === 404) {
                callback({ id: voteId, count: 0 });
                return;
            }
            return r.json();
        })
            .then(function (r) {
            callback(__assign({ id: voteId }, r));
        });
    };
    var setVote = function (id) {
        var _a;
        if (id) {
            if (profile &&
                isUserVotedOrUndefined(voteData, (_a = profile === null || profile === void 0 ? void 0 : profile.accountId) !== null && _a !== void 0 ? _a : '')) {
                return false;
            }
            var newPost = post;
            LikeAPI.Like({
                entityId: id,
                entityType: 'superpuperimage'
            })
                .then(function (r) {
                if ((r === null || r === void 0 ? void 0 : r.status) === 200) {
                    toasts.info(t('editor.vote.success_vote_msg'));
                    return;
                }
                toasts.error(t('editor.vote.error_vote_msg'));
            })
                .catch(function (err) { return toasts.error(t('editor.vote.error_vote_msg')); });
            setTimeout(function () {
                var _a, _b;
                setVote1(null);
                setVote2(null);
                fetchVotes((_a = voteData[0]) === null || _a === void 0 ? void 0 : _a.id, post === null || post === void 0 ? void 0 : post.postId, setVote1);
                fetchVotes((_b = voteData[1]) === null || _b === void 0 ? void 0 : _b.id, post === null || post === void 0 ? void 0 : post.postId, setVote2);
            }, 400);
            dispatch(updateLongReadPost('', newPost, true));
        }
    };
    useEffect(function () {
        if (isAttachmentLiked === null) {
            setAttachmentLikes((post === null || post === void 0 ? void 0 : post.isAttachmentLiked) || null);
        }
    }, [post, isAttachmentLiked]);
    useEffect(function () {
        if (post.attachments && (voteData === null || voteData === void 0 ? void 0 : voteData.length) < 2 && fingerprintId) {
            var list = post.attachments.map(function (item) { return item.fileContainerId; });
            fetchVotes(list[0], post === null || post === void 0 ? void 0 : post.postId, setVote1);
            fetchVotes(list[1], post === null || post === void 0 ? void 0 : post.postId, setVote2);
        }
    }, [fingerprintId]);
    useEffect(function () {
        if (vote1 && vote2) {
            setVoteData([vote1, vote2]);
        }
    }, [vote1, vote2]);
    useEffect(function () {
        if (lastVote) {
            setCurrentVote(lastVote);
        }
    }, [lastVote]);
    var handleSetVoteClick = function (val) {
        setCurrentVote(val);
        setVote(val, post === null || post === void 0 ? void 0 : post.postId);
    };
    var handleSaveResultClick = function (list) {
        var _a;
        if (isAttachmentLiked) {
            toasts.error(t('editor.vote.error_attachments_likes'));
            return false;
        }
        var newPost = post;
        var count = (_a = list === null || list === void 0 ? void 0 : list.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.newCount) > 0; })) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
            var id = _a.id, newCount = _a.newCount;
            return ({ id: id, newCount: newCount });
        });
        count.forEach(function (i) { return setCustomVote(i === null || i === void 0 ? void 0 : i.id, post === null || post === void 0 ? void 0 : post.postId, i === null || i === void 0 ? void 0 : i.newCount); });
        setTimeout(function () {
            var _a, _b;
            setVote1(null);
            setVote2(null);
            fetchVotes((_a = voteData[0]) === null || _a === void 0 ? void 0 : _a.id, post === null || post === void 0 ? void 0 : post.postId, setVote1);
            fetchVotes((_b = voteData[1]) === null || _b === void 0 ? void 0 : _b.id, post === null || post === void 0 ? void 0 : post.postId, setVote2);
        }, 100);
        var timeout = 3000;
        setTimeout(function () {
            setAttachmentLikes(true);
            dispatch(updateLongReadPost('', __assign(__assign({}, newPost), { isAttachmentLiked: true }), true));
            dispatch(toggleLongReadPostUpdate(0, false));
        }, 500);
        setTimeout(function () {
            return dispatch(getLongReadPosts(newPost.userId, newPost.longreadId, sign
            // this.props.thematic
            ));
        }, timeout);
    };
    var isLoading = post.postId === 'loading';
    var isMultipleLoading = ((_b = (_a = post.postId) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.indexOf('loading')) !== -1;
    var isEmptyVotes = useMemo(function () { return votes.every(function (v) { return (v === null || v === void 0 ? void 0 : v.count) === 0; }); }, [votes]);
    var shouldVisibleAdminBlock = useMemo(function () {
        /* (isUpdatePost || !isEmptyVotes) */ return !!isAuth &&
            isUpdatePost &&
            votes &&
            !!(votes === null || votes === void 0 ? void 0 : votes.length);
    }, [isUpdatePost, isEmptyVotes, votes, isAuth]);
    var shouldVisibleRadioButtons = useMemo(function () {
        return !isUpdatePost &&
            !isEditable &&
            votes &&
            !!(votes === null || votes === void 0 ? void 0 : votes.length) &&
            (!lastVote || lastVote === '') &&
            !disableVoting;
    }, [isUpdatePost, isEditable, votes, lastVote, disableVoting]);
    var isNotEditable = useMemo(function () { return !isUpdatePost && !isEditable; }, [isUpdatePost, isEditable]);
    var isMoreBlockFirst = useMemo(function () { var _a; return votes && firstContainerId && firstContainerId === ((_a = votes === null || votes === void 0 ? void 0 : votes[0]) === null || _a === void 0 ? void 0 : _a.id); }, [votes, firstContainerId]);
    var shouldVisibleResultBlock = useMemo(function () {
        return !isEmptyVotes && !shouldVisibleAdminBlock && lastVote && lastVote !== '';
    }, [isEmptyVotes, shouldVisibleAdminBlock, lastVote]);
    var isAlreadyEdited = useMemo(function () { return !!isAttachmentLiked; }, [isAttachmentLiked]);
    var updatedAt = new Date(post.dateLastChange).getTime();
    var hasNewFormatting = updatedAt > NEW_TEXT_FORMATTING_THRESHOLD;
    return (React.createElement(Wrap, { blockOffset: isNotEditable },
        (isLoading || post.postId === 'updating' || isMultipleLoading) && (React.createElement(LoaderProgressBar, null)),
        React.createElement(BigImageBlock, { isDragging: isDragging, colorStyle: colorStyle, isLoadingPost: !!(isLoading || post.postId === 'updating' || isMultipleLoading), postType: postType.type, viewType: viewType, ref: container },
            !isUpdatePost && isEditable && !isLoading && (React.createElement(EditorOverlayNew, { dragHandleProps: dragHandleProps, post: post })),
            React.createElement(FlexBox, { direction: 'row', gx: 24, gxMobile: is375 ? 10 : 16, width: '100%' },
                React.createElement(FlexBox, { width: '50%', style: { position: 'relative' }, ref: testFirstContainer },
                    isUpdatePost && isEditable && !isLoading && (React.createElement(EditorOverlayNew, { dragHandleProps: dragHandleProps, post: post })),
                    React.createElement(ConditionalLazyLoad, { isLazy: !isPrint, className: 'lazy-img-container img-wrapper' },
                        (isLoading || isMultipleLoading) && (React.createElement("img", { src: "".concat(firstLoading), alt: 'super-puper-vote-img' })),
                        !isLoading && resizeFirstImage && (React.createElement("img", { 
                            // src={`${urlApi().getImageQueryLink()}${resizeFirstImage}`}
                            src: "".concat(urlApi().getImageQueryLink()).concat(testFirst === null || testFirst === void 0 ? void 0 : testFirst.url), alt: 'super-puper-vote-img' })))),
                React.createElement(FlexBox, { width: '50%', style: { position: 'relative' }, ref: testSecondContainer },
                    isUpdatePost && isEditable && !isLoading && (React.createElement(EditorOverlayNew, { dragHandleProps: dragHandleProps, post: post })),
                    React.createElement(ConditionalLazyLoad, { isLazy: !isPrint, className: 'lazy-img-container img-wrapper' },
                        (isLoading || isMultipleLoading) && (React.createElement("img", { src: "".concat(secondLoading), alt: 'super-puper-vote-img' })),
                        !isLoading && resizeSecondImage && (React.createElement(React.Fragment, null,
                            React.createElement("img", { 
                                // src={`${urlApi().getImageQueryLink()}${resizeSecondImage}`}
                                src: "".concat(urlApi().getImageQueryLink()).concat(testSecond === null || testSecond === void 0 ? void 0 : testSecond.url), alt: 'super-puper-vote-img' })))))),
            shouldVisibleRadioButtons && (React.createElement(FlexBox, { offsetTop: smSize ? '14px' : '24px' },
                React.createElement(VoteRadioBlock, { votes: votes, onVoteChange: handleSetVoteClick, currentVote: currentVote, colorStyle: colorStyle, isMoreBlockFirst: isMoreBlockFirst }))),
            shouldVisibleResultBlock && (React.createElement(FlexBox, { offsetBottom: shouldVisibleAdminBlock ? (smSize ? '14px' : '24px') : 0, offsetTop: smSize ? '14px' : '24px' },
                React.createElement(VoteResultBlock, { votes: votes, isMoreBlockFirst: isMoreBlockFirst }))),
            shouldVisibleAdminBlock && (React.createElement(VoteAdminWrapper, { isDark: colorStyle === 'grey' },
                React.createElement(VoteAdminBlock, { votes: votes, onSave: handleSaveResultClick, total: 0, visibleAdminBlock: isUpdatePost, isDark: colorStyle === 'grey', isMoreBlockFirst: isMoreBlockFirst, isAlreadyEdited: isAlreadyEdited })))),
        !isDragging && isDragContinue && (React.createElement(DragWrap, { className: 'drag__hide' },
            React.createElement(DragLine, null),
            React.createElement(DragText, null, "Drop to place")))));
};
export default memo(VotePostBlock);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=votepostblock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { memo, useCallback, useRef, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import LazyLoad from 'react-lazyload';
import urlApi from '../../../../../actions/urlApi';
import { DragDropContext } from 'react-beautiful-dnd';
import { LayoutConst, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE } from '../../../../../constants/media';
import useResizedPostImage from '../../../../../hooks/useResizedPostImage';
import AspectRatio from '../../../../AspectRatio';
import { FontSizes, MAC13_COLORED_FONT_SIZE, POST_SHADOW } from '../../../../../constants/theme';
import { FlexBox, useBreakpoint, useResizedImage, useToasts } from '@brg/ui';
import { VoteRadioBlock } from '../components/voteradioblock';
import { VoteAdminBlock } from '../components/voteadminblock';
import { updateLongReadPost } from '../../../../../actions/updateLongReadPost';
import { getLongReadPosts } from '../../../../../actions/getLongReadPosts';
import VoteDragColumn from '../components/votedragcolumn';
import { API, Endpoints, LikeAPI } from '@brg/api';
import { useAuth, useFingerprintId, useProfile } from '@brg/auth';
import useLocalization from '../../../../../hooks/useLocalization';
import { VoteResultBlock } from '../components/voteresultblock';
import useCommonProps from '../../../../../hooks/useCommonProps';
import EditorOverlayNew from '../../editor/EditorOverlayNew';
import { OverlayInnerNew } from '../../editor/EditorOverlayNew/styles';
import { CardOverlayInner } from '../../editor/CardOverlay/styles';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding-top: ", ";\n\n  &:hover {\n    .drag__hide {\n      display: flex;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n  }\n"], ["\n  position: relative;\n  padding-top: ", ";\n\n  &:hover {\n    .drag__hide {\n      display: flex;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n    ", " {\n      opacity: 1 !important;\n    }\n  }\n"])), function (_a) {
    var blockOffset = _a.blockOffset;
    return (blockOffset ? '30px' : 0);
}, OverlayInnerNew, CardOverlayInner);
var NEW_TEXT_FORMATTING_THRESHOLD = new Date(2022, 4, 5, 13).getTime();
var BigImageBlock = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  max-height: 200vw;\n  overflow: hidden;\n\n  transform: ", ";\n  transform-origin: ", ";\n  right: ", ";\n  top: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  opacity: ", ";\n  background-color: #000000;\n\n  a {\n    display: block;\n  }\n\n  .edit__toggle {\n    display: none;\n  }\n\n  .img-wrapper {\n    width: 564px !important;\n    max-height: 792px !important;\n\n    @media (max-width: 1440px), (max-height: 920px) {\n      width: 432px !important;\n      max-height: 594px !important;\n    }\n\n    @media (max-width: ", "px) {\n      width: 100% !important;\n      max-height: none !important;\n      height: auto !important;\n    }\n  }\n\n  img {\n    width: 564px !important;\n    height: 792px !important;\n    @media (max-width: 1440px), (max-height: 920px) {\n      width: 432px !important;\n      height: 594px !important;\n    }\n\n    @media (max-width: ", "px) {\n      width: 100% !important;\n      max-height: none !important;\n      height: auto !important;\n    }\n  }\n\n  &:hover {\n    .edit__toggle {\n      display: flex;\n      color: #151514;\n    }\n  }\n\n  @media (max-width: 940px) {\n    padding-left: ", ";\n    padding-right: ", ";\n\n    .lazy-img-container {\n      width: 100%;\n    }\n  }\n"], ["\n  position: relative;\n  max-height: 200vw;\n  overflow: hidden;\n\n  transform: ", ";\n  transform-origin: ", ";\n  right: ", ";\n  top: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  opacity: ", ";\n  background-color: #000000;\n\n  a {\n    display: block;\n  }\n\n  .edit__toggle {\n    display: none;\n  }\n\n  .img-wrapper {\n    width: 564px !important;\n    max-height: 792px !important;\n\n    @media (max-width: 1440px), (max-height: 920px) {\n      width: 432px !important;\n      max-height: 594px !important;\n    }\n\n    @media (max-width: ", "px) {\n      width: 100% !important;\n      max-height: none !important;\n      height: auto !important;\n    }\n  }\n\n  img {\n    width: 564px !important;\n    height: 792px !important;\n    @media (max-width: 1440px), (max-height: 920px) {\n      width: 432px !important;\n      height: 594px !important;\n    }\n\n    @media (max-width: ", "px) {\n      width: 100% !important;\n      max-height: none !important;\n      height: auto !important;\n    }\n  }\n\n  &:hover {\n    .edit__toggle {\n      display: flex;\n      color: #151514;\n    }\n  }\n\n  @media (max-width: 940px) {\n    padding-left: ", ";\n    padding-right: ", ";\n\n    .lazy-img-container {\n      width: 100%;\n    }\n  }\n"])), function (props) {
    return props.isDragging ? 'scale(0.4) rotate(10deg)' : 'scale(1)';
}, function (props) { return (props.isDragging ? 'left top' : 'center'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (_a) {
    var viewType = _a.viewType;
    return viewType === 'shadow' ? POST_SHADOW : 'none';
}, function (props) { return (props.isDragging ? '2' : '4'); }, function (props) { return (props.isLoadingPost ? '0.5' : '1'); }, MEDIA_QUERY_MOBILE, MEDIA_QUERY_MOBILE, function (props) { return (props.postType === 'normal' ? '15px' : '0'); }, function (props) { return (props.postType === 'normal' ? '15px' : '0'); });
var DragWrap = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: none;\n  align-items: center;\n  opacity: 0.3;\n  cursor: pointer;\n  margin-top: 10px;\n  position: absolute;\n  width: 100%;\n"], ["\n  display: none;\n  align-items: center;\n  opacity: 0.3;\n  cursor: pointer;\n  margin-top: 10px;\n  position: absolute;\n  width: 100%;\n"])));
var DragLine = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: 1px dashed #fefefe;\n  flex: 1;\n"], ["\n  border: 1px dashed #fefefe;\n  flex: 1;\n"])));
var DragText = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: #fefefe;\n  margin-left: 8px;\n"], ["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: #fefefe;\n  margin-left: 8px;\n"])));
var VoteAdminWrapper = styled(FlexBox)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  background-color: transparent;\n"], ["\n  width: 100%;\n  background-color: transparent;\n"])));
var progressAnim = keyframes(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n"], ["\n  from {\n    width: 0%;\n  }\n\n  to {\n    width: 100%;\n  }\n"])));
var LoaderProgressBar = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  background: #f1db63;\n  top: 0;\n  left: 0;\n  height: 6px;\n  animation-name: ", ";\n  animation-fill-mode: forwards;\n  animation-direction: normal;\n  animation-duration: 1.5s;\n"], ["\n  position: absolute;\n  background: #f1db63;\n  top: 0;\n  left: 0;\n  height: 6px;\n  animation-name: ", ";\n  animation-fill-mode: forwards;\n  animation-direction: normal;\n  animation-duration: 1.5s;\n"])), progressAnim);
var OneImgBox = styled(FlexBox)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n\n  img {\n    width: 100% !important;\n    height: 100% !important;\n  }\n"], ["\n  width: 100%;\n\n  img {\n    width: 100% !important;\n    height: 100% !important;\n  }\n"])));
var getVotesImages = function (post) {
    var _a;
    return post &&
        ((_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a.reduce(function (res, item) {
            var _a = item.files, files = _a === void 0 ? [] : _a;
            return __spreadArray(__spreadArray([], res, true), [files], false);
        }, []));
};
var getLoadingVotesImages = function (post) {
    var _a;
    return post &&
        ((_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a.reduce(function (res, item) {
            var _a = item.file, file = _a === void 0 ? [] : _a;
            return __spreadArray(__spreadArray([], res, true), [file === null || file === void 0 ? void 0 : file.url], false);
        }, []));
};
var isUserVotedOrUndefined = function (votes, userId) {
    return votes === null || votes === void 0 ? void 0 : votes.some(function (i) { var _a; return (_a = i === null || i === void 0 ? void 0 : i.usersIdsLike) === null || _a === void 0 ? void 0 : _a.includes(userId); });
};
var getTotalCount = function (vote) {
    return vote.map(function (i) { return Number(i.count); }).reduce(function (sum, current) { return sum + current; }, 0);
};
var getTotalPercent = function (totalCount, count) {
    var total = (count * 100) / totalCount;
    if (total === 0 || isNaN(total))
        return 0;
    return total.toFixed();
};
export var ConditionalLazyLoad = function (_a) {
    var children = _a.children, className = _a.className, isLazy = _a.isLazy;
    if (isLazy)
        return (React.createElement(LazyLoad, { offset: 2000, once: true, className: className }, children));
    return React.createElement("div", { className: className }, children);
};
var VotePostBlock = function (props) {
    var _a, _b;
    var post = props.post, toggleLongReadPostUpdate = props.toggleLongReadPostUpdate, dragHandleProps = props.dragHandleProps, isDragging = props.isDragging, isDragContinue = props.isDragContinue, isEditable = props.isEditable, linkTo = props.linkTo, onOverlayedImageClick = props.onOverlayedImageClick, colorStyle = props.colorStyle, viewType = props.viewType, isAdmin = props.isAdmin, votesContent = props.votesContent, isUpdatePost = props.isUpdatePost, isSaveVoting = props.isSaveVoting;
    var dispatch = useDispatch();
    var auth = useAuth();
    var profile = useProfile();
    var toasts = useToasts();
    var t = useLocalization().t;
    var postType = useSelector(function (state) { return state.postType; });
    var container = useRef();
    var is375 = useBreakpoint(375);
    var isMac13 = useBreakpoint(MEDIA_QUERY);
    var smHeight = window.innerHeight < MEDIA_QUERY_HEIGHT;
    var _c = useCommonProps(), isPrint = _c.isPrint, disableVoting = _c.disableVoting, sign = _c.sign;
    var fingerprintId = useFingerprintId();
    var _d = useState([]), voteData = _d[0], setVoteData = _d[1];
    var _e = useState(''), currentVote = _e[0], setCurrentVote = _e[1];
    // добавлял ли админ результаты голосования из телеграмма
    var _f = useState(null), isAttachmentLiked = _f[0], setAttachmentLikes = _f[1];
    var _g = votesContent || {}, isSpVote = _g.isSpVote, isAuth = _g.isAuth, voteCollection = _g.voteCollection;
    var _h = getVotesImages(post), first = _h[0], second = _h[1];
    var _j = getLoadingVotesImages(post), firstLoading = _j[0], secondLoading = _j[1];
    var _k = useState(), vote1 = _k[0], setVote1 = _k[1];
    var _l = useState(), vote2 = _l[0], setVote2 = _l[1];
    var needLogin = useMemo(function () { return !profile; }, [profile]);
    var originalFirst = (first || [])[0];
    var secondFirst = (second || [])[0];
    var _m = useResizedImage(first !== null && first !== void 0 ? first : []), testFirst = _m[0], testFirstContainer = _m[1];
    var _o = useResizedImage(second !== null && second !== void 0 ? second : []), testSecond = _o[0], testSecondContainer = _o[1];
    var _p = originalFirst || {}, resizeFirstImage = _p.url, firstContainerId = _p.containerId;
    var _q = secondFirst || {}, resizeSecondImage = _q.url, secondContainerId = _q.containerId;
    var isUpdating = useMemo(function () { return post.postId === 'updating'; }, [post]);
    var smSize = useMemo(function () { return isMac13 || smHeight; }, [isMac13, smHeight]);
    // Для теста
    // const test = [
    //   {id: '123', count: 11120, percent: 72, },
    //   {id: '456', count: 0, percent: 28},
    // ]
    // const votes = test;
    var votes = useMemo(function () {
        var _a;
        if (voteData === null || voteData === void 0 ? void 0 : voteData.length) {
            return (_a = voteData === null || voteData === void 0 ? void 0 : voteData.map(function (v) {
                return __assign(__assign({}, v), { count: (v === null || v === void 0 ? void 0 : v.count) || 0 });
            })) === null || _a === void 0 ? void 0 : _a.map(function (i, idx, arr) {
                return __assign(__assign({}, i), { percent: getTotalPercent(getTotalCount(arr), i.count) });
            });
        }
        return [];
    }, [post, voteData]);
    var lastVote = useMemo(function () {
        var _a, _b;
        if (votes === null || votes === void 0 ? void 0 : votes.length) {
            return (_b = (_a = votes === null || votes === void 0 ? void 0 : votes.filter(function (v) {
                var _a;
                if ((_a = v === null || v === void 0 ? void 0 : v.usersIdsLike) === null || _a === void 0 ? void 0 : _a.includes(needLogin ? fingerprintId : profile === null || profile === void 0 ? void 0 : profile.accountId))
                    return v;
            })) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id;
        }
    }, [votes, profile, fingerprintId, needLogin]);
    var setCustomVote = function (id, postId, count) {
        API.request()
            .endpoint(Endpoints.qualities)
            .url('/Like/LikeOnCustomValue')
            .post()
            .body({
            entityId: id,
            entityType: 'superpuperimage',
            count: count
        })
            .send();
    };
    var fetchVotes = function (voteId, postId, callback, isUpdate) {
        LikeAPI.GetLike({
            entityId: voteId,
            entityType: 'superpuperimage'
        })
            .then(function (r) {
            if ((r === null || r === void 0 ? void 0 : r.status) === 404) {
                callback({ id: voteId, count: 0 });
                return;
            }
            return r.json();
        })
            .then(function (r) {
            callback(__assign({ id: voteId }, r));
        });
    };
    var setVote = function (id) {
        var _a;
        if (id) {
            if (profile &&
                isUserVotedOrUndefined(voteData, (_a = profile === null || profile === void 0 ? void 0 : profile.accountId) !== null && _a !== void 0 ? _a : '')) {
                return false;
            }
            var newPost = post;
            LikeAPI.Like({
                entityId: id,
                entityType: 'superpuperimage'
            })
                .then(function (r) {
                if ((r === null || r === void 0 ? void 0 : r.status) === 200) {
                    toasts.info(t('editor.vote.success_vote_msg'));
                    return;
                }
                toasts.error(t('editor.vote.error_vote_msg'));
            })
                .catch(function (err) { return toasts.error(t('editor.vote.error_vote_msg')); });
            setTimeout(function () {
                var _a, _b;
                setVote1(null);
                setVote2(null);
                fetchVotes((_a = voteData[0]) === null || _a === void 0 ? void 0 : _a.id, post === null || post === void 0 ? void 0 : post.postId, setVote1);
                fetchVotes((_b = voteData[1]) === null || _b === void 0 ? void 0 : _b.id, post === null || post === void 0 ? void 0 : post.postId, setVote2);
            }, 400);
            dispatch(updateLongReadPost('', newPost, true));
        }
    };
    useEffect(function () {
        if (isAttachmentLiked === null) {
            setAttachmentLikes((post === null || post === void 0 ? void 0 : post.isAttachmentLiked) || null);
        }
    }, [post, isAttachmentLiked]);
    useEffect(function () {
        if (post.attachments && (voteData === null || voteData === void 0 ? void 0 : voteData.length) < 2 && fingerprintId) {
            var list = post.attachments.map(function (item) { return item.fileContainerId; });
            fetchVotes(list[0], post === null || post === void 0 ? void 0 : post.postId, setVote1);
            fetchVotes(list[1], post === null || post === void 0 ? void 0 : post.postId, setVote2);
        }
    }, [fingerprintId]);
    useEffect(function () {
        if (vote1 && vote2) {
            setVoteData([vote1, vote2]);
        }
    }, [vote1, vote2]);
    useEffect(function () {
        if (lastVote) {
            setCurrentVote(lastVote);
        }
    }, [lastVote]);
    var handleSetVoteClick = function (val) {
        setCurrentVote(val);
        setVote(val, post === null || post === void 0 ? void 0 : post.postId);
    };
    var handleSaveResultClick = function (list) {
        var _a;
        if (isAttachmentLiked) {
            toasts.error(t('editor.vote.error_attachments_likes'));
            return false;
        }
        var newPost = post;
        var count = (_a = list === null || list === void 0 ? void 0 : list.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.newCount) > 0; })) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
            var id = _a.id, newCount = _a.newCount;
            return ({ id: id, newCount: newCount });
        });
        count.forEach(function (i) { return setCustomVote(i === null || i === void 0 ? void 0 : i.id, post === null || post === void 0 ? void 0 : post.postId, i === null || i === void 0 ? void 0 : i.newCount); });
        setTimeout(function () {
            var _a, _b;
            setVote1(null);
            setVote2(null);
            fetchVotes((_a = voteData[0]) === null || _a === void 0 ? void 0 : _a.id, post === null || post === void 0 ? void 0 : post.postId, setVote1);
            fetchVotes((_b = voteData[1]) === null || _b === void 0 ? void 0 : _b.id, post === null || post === void 0 ? void 0 : post.postId, setVote2);
        }, 100);
        var timeout = 3000;
        setTimeout(function () {
            setAttachmentLikes(true);
            dispatch(updateLongReadPost('', __assign(__assign({}, newPost), { isAttachmentLiked: true }), true));
            dispatch(toggleLongReadPostUpdate(0, false));
        }, 500);
        setTimeout(function () {
            return dispatch(getLongReadPosts(newPost.userId, newPost.longreadId, sign
            // this.props.thematic
            ));
        }, timeout);
    };
    var isLoading = post.postId === 'loading';
    var isMultipleLoading = ((_b = (_a = post.postId) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.indexOf('loading')) !== -1;
    var isEmptyVotes = useMemo(function () { return votes.every(function (v) { return (v === null || v === void 0 ? void 0 : v.count) === 0; }); }, [votes]);
    var shouldVisibleAdminBlock = useMemo(function () {
        /* (isUpdatePost || !isEmptyVotes) */ return !!isAuth &&
            isUpdatePost &&
            votes &&
            !!(votes === null || votes === void 0 ? void 0 : votes.length);
    }, [isUpdatePost, isEmptyVotes, votes, isAuth]);
    var shouldVisibleRadioButtons = useMemo(function () {
        return !isUpdatePost &&
            !isEditable &&
            votes &&
            !!(votes === null || votes === void 0 ? void 0 : votes.length) &&
            (!lastVote || lastVote === '') &&
            !disableVoting;
    }, [isUpdatePost, isEditable, votes, lastVote, disableVoting]);
    var isNotEditable = useMemo(function () { return !isUpdatePost && !isEditable; }, [isUpdatePost, isEditable]);
    var isMoreBlockFirst = useMemo(function () { var _a; return votes && firstContainerId && firstContainerId === ((_a = votes === null || votes === void 0 ? void 0 : votes[0]) === null || _a === void 0 ? void 0 : _a.id); }, [votes, firstContainerId]);
    var shouldVisibleResultBlock = useMemo(function () {
        return !isEmptyVotes && !shouldVisibleAdminBlock && lastVote && lastVote !== '';
    }, [isEmptyVotes, shouldVisibleAdminBlock, lastVote]);
    var isAlreadyEdited = useMemo(function () { return !!isAttachmentLiked; }, [isAttachmentLiked]);
    var updatedAt = new Date(post.dateLastChange).getTime();
    var hasNewFormatting = updatedAt > NEW_TEXT_FORMATTING_THRESHOLD;
    return (React.createElement(Wrap, { blockOffset: isNotEditable },
        (isLoading || post.postId === 'updating' || isMultipleLoading) && (React.createElement(LoaderProgressBar, null)),
        React.createElement(BigImageBlock, { isDragging: isDragging, colorStyle: colorStyle, isLoadingPost: !!(isLoading || post.postId === 'updating' || isMultipleLoading), postType: postType.type, viewType: viewType, ref: container },
            !isUpdatePost && isEditable && !isLoading && (React.createElement(EditorOverlayNew, { dragHandleProps: dragHandleProps, post: post })),
            React.createElement(FlexBox, { direction: 'row', gx: 24, gxMobile: is375 ? 10 : 16, width: '100%' },
                React.createElement(FlexBox, { width: '50%', style: { position: 'relative' }, ref: testFirstContainer },
                    isUpdatePost && isEditable && !isLoading && (React.createElement(EditorOverlayNew, { dragHandleProps: dragHandleProps, post: post })),
                    React.createElement(ConditionalLazyLoad, { isLazy: !isPrint, className: 'lazy-img-container img-wrapper' },
                        (isLoading || isMultipleLoading) && (React.createElement("img", { src: "".concat(firstLoading), alt: 'super-puper-vote-img' })),
                        !isLoading && resizeFirstImage && (React.createElement("img", { 
                            // src={`${urlApi().getImageQueryLink()}${resizeFirstImage}`}
                            src: "".concat(urlApi().getImageQueryLink()).concat(testFirst === null || testFirst === void 0 ? void 0 : testFirst.url), alt: 'super-puper-vote-img' })))),
                React.createElement(FlexBox, { width: '50%', style: { position: 'relative' }, ref: testSecondContainer },
                    isUpdatePost && isEditable && !isLoading && (React.createElement(EditorOverlayNew, { dragHandleProps: dragHandleProps, post: post })),
                    React.createElement(ConditionalLazyLoad, { isLazy: !isPrint, className: 'lazy-img-container img-wrapper' },
                        (isLoading || isMultipleLoading) && (React.createElement("img", { src: "".concat(secondLoading), alt: 'super-puper-vote-img' })),
                        !isLoading && resizeSecondImage && (React.createElement(React.Fragment, null,
                            React.createElement("img", { 
                                // src={`${urlApi().getImageQueryLink()}${resizeSecondImage}`}
                                src: "".concat(urlApi().getImageQueryLink()).concat(testSecond === null || testSecond === void 0 ? void 0 : testSecond.url), alt: 'super-puper-vote-img' })))))),
            shouldVisibleRadioButtons && (React.createElement(FlexBox, { offsetTop: smSize ? '14px' : '24px' },
                React.createElement(VoteRadioBlock, { votes: votes, onVoteChange: handleSetVoteClick, currentVote: currentVote, colorStyle: colorStyle, isMoreBlockFirst: isMoreBlockFirst }))),
            shouldVisibleResultBlock && (React.createElement(FlexBox, { offsetBottom: shouldVisibleAdminBlock ? (smSize ? '14px' : '24px') : 0, offsetTop: smSize ? '14px' : '24px' },
                React.createElement(VoteResultBlock, { votes: votes, isMoreBlockFirst: isMoreBlockFirst }))),
            shouldVisibleAdminBlock && (React.createElement(VoteAdminWrapper, { isDark: colorStyle === 'grey' },
                React.createElement(VoteAdminBlock, { votes: votes, onSave: handleSaveResultClick, total: 0, visibleAdminBlock: isUpdatePost, isDark: colorStyle === 'grey', isMoreBlockFirst: isMoreBlockFirst, isAlreadyEdited: isAlreadyEdited })))),
        !isDragging && isDragContinue && (React.createElement(DragWrap, { className: 'drag__hide' },
            React.createElement(DragLine, null),
            React.createElement(DragText, null, "Drop to place")))));
};
export default memo(VotePostBlock);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=votepostblock.js.map